/**
 * File navigation.ts
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

(function () {
	const siteNavigation = document.getElementById('site-navigation') as HTMLElement | null;

	if (!siteNavigation) return;

	const button = siteNavigation.querySelector('button') as HTMLButtonElement | null;
	if (!button) return;

	const menu = siteNavigation.querySelector('ul') as HTMLUListElement | null;
	if (!menu) {
		button.style.display = 'none';
		return;
	}

	if (!menu.classList.contains('nav-menu')) {
		menu.classList.add('nav-menu');
	}

	button.addEventListener('click', () => {
		siteNavigation.classList.toggle('toggled');

		const expanded = button.getAttribute('aria-expanded') === 'true';
		button.setAttribute('aria-expanded', String(!expanded));
	});

	document.addEventListener('click', (event: MouseEvent) => {
		if (!siteNavigation.contains(event.target as Node)) {
			siteNavigation.classList.remove('toggled');
			button.setAttribute('aria-expanded', 'false');
		}
	});

	const links = menu.querySelectorAll('a');
	const linksWithChildren = menu.querySelectorAll<HTMLAnchorElement>(
		'.menu-item-has-children > a, .page_item_has_children > a'
	);

	links.forEach(link => {
		link.addEventListener('focus', toggleFocus, true);
		link.addEventListener('blur', toggleFocus, true);
	});

	linksWithChildren.forEach(link => {
		link.addEventListener('touchstart', toggleFocus, false);
	});

	function toggleFocus(event: Event): void {
		if (event.type === 'focus' || event.type === 'blur') {
			let el = event.target as HTMLElement;
			while (el && !el.classList.contains('nav-menu')) {
				if (el.tagName.toLowerCase() === 'li') {
					el.classList.toggle('focus');
				}
				el = el.parentElement as HTMLElement;
			}
		}

		if (event.type === 'touchstart') {
			const menuItem = (event.target as HTMLElement).parentElement as HTMLElement;
			event.preventDefault();

			const siblings = Array.from(menuItem.parentElement?.children || []);
			if (!siblings) return;

			for (const sibling of siblings) {
				if (sibling !== menuItem) {
					(sibling as HTMLElement).classList.remove('focus');
				}
			}

			menuItem.classList.toggle('focus');
		}
	}
})();
